
<div class="modal active">
    <div class="modal__container modal__container--lg">
      <div class="fields">
        <h2>Antenna Model Selection</h2>
        <div class="close" (click)="bsModalRef.hide()"><img src="/assets/img/close-white.svg" alt="" /></div>
        <div class="fields__container">
          <form autocomplete="off"  name="antennaPatternForm" #ngForm="ngForm" id="antennaPatternForm" class="active">
            <div class="fields__block">
              <div class="fields__block__section">
                <div class="table-fields">
                  <div style="max-height: 241px; overflow-y: scroll;">
                    <table>
                      <thead>
                        <tr>
                          <th scope="col">Antenna Model</th>
                          <th scope="col">Antenna Pattern File</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr mdbTableCol *ngFor="let model of this.antennaPatternService.antennaModels" 
                        [class.highlighted]="model.selected" (click)="selectRow(model)">
                          <td>{{ model.modelName }}</td>
                          <td>
                            <div class="btn">
                              <a (click)="downloadFile(model)">Download</a>
                            </div>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>
            <div class="fields__btn">
              <button (click)="bsModalRef.hide()" type="submit" [ngClass]="'blue'" >
                Close
              </button>
              <button (click)="addAntennaModel()" type="submit" [ngClass]="'blue'">
                Add Antenna Model
              </button>
              <button (click)="editSelectedAntennaModel()" type="submit" [ngClass]="selectedRow != null && this.selectedRow.id != null? 'blue' : 'gray'" >
                Edit Antenna Model
              </button>
              <button (click)="deleteSelectedRow()" type="submit" [ngClass]="selectedRow != null && this.selectedRow.id != null ? 'blue' : 'gray'" >
                Remove Antenna Model
              </button>
            </div>
          </form>
  
        </div>
      </div>
    </div>
  </div>
  
